import { render, staticRenderFns } from "./Instellingen.vue?vue&type=template&id=29b5cc1b&scoped=true&"
import script from "./Instellingen.vue?vue&type=script&lang=js&"
export * from "./Instellingen.vue?vue&type=script&lang=js&"
import style0 from "./Instellingen.vue?vue&type=style&index=0&id=29b5cc1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5cc1b",
  null
  
)

export default component.exports